import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { NgxPaginationModule } from 'ngx-pagination';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSliderModule } from '@angular/material/slider';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatLegacyRadioModule as MatRadioModule } from '@angular/material/legacy-radio';
import { NgxMaskDirective, NgxMaskPipe } from 'ngx-mask';

import { AlertModule } from './../../common/alert/alert.module';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatProgressBarModule } from '@angular/material/progress-bar';

import { MatLegacyCardModule as MatCardModule } from '@angular/material/legacy-card';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';
import { MatTooltipModule } from '@angular/material/tooltip';

import { EmailAssessmentRoutingModule } from './email-assessment-routing.module';
import { SignaturePadComponent } from '../signature-pad/signature-pad.component';
import { EmailAssessmentComponent } from './email-assessment.component';
import { ConfirmationDialogModule } from 'src/app/common/confirmation-dialog/confirmation-dialog.module';
import { ConfirmSaveModule } from 'src/app/common/confirm-save/confirm-save.module';
import { ConfirmationSuccessEmailComponent } from 'src/app/common/confirmation-success-email/confirmation-success-email.component';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from 'src/app/shared/shared/shared.module';
import { ConfirmDiscardModule } from 'src/app/common/confirm-discard/confirm-discard.module';
@NgModule({
  declarations: [EmailAssessmentComponent,
    ConfirmationSuccessEmailComponent,
    SignaturePadComponent],
  imports: [
    CommonModule,
    EmailAssessmentRoutingModule,
    TabsModule.forRoot(),
    NgbModule,
    MatCardModule,
    MatSliderModule,
    MatSidenavModule,
    MatProgressBarModule,
    CollapseModule.forRoot(),
    NgxPaginationModule,
    MatSelectModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatMomentDateModule,
    MatRadioModule,
    FormsModule,
    ReactiveFormsModule,
    NgxMaskPipe,
    NgxMaskDirective,
    AlertModule,
    MatCheckboxModule,
    MatTableModule,
    ConfirmationDialogModule,
    MatTooltipModule,
    ConfirmSaveModule,
    SharedModule,
    ConfirmDiscardModule,
    NgxMatSelectSearchModule,
    TranslateModule.forChild()
  ],
  exports: [
    MatSelectModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatMomentDateModule,
    MatRadioModule,
    MatTableModule,
    MatTooltipModule,
    SignaturePadComponent
  ],
})
export class EmailAssessmentModule { }
